import type { PostHog } from 'posthog-js'

let posthog: null | PostHog

if (import.meta.env.MODE === 'production') {
  import('posthog-js').then((module) => {
    posthog = module.posthog.init(
      'phc_b8C0G8j9QLWNabkXRURrFMKazb1JPjgFrotcp52s43J',
      {
        api_host: 'https://us.i.posthog.com',
        defaults: '2025-11-30',
      },
    )
  })
}

export { posthog }
